:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-row{flex-direction:row;}
:root ._width-10037{width:100%;}
:root ._pr-t-space-lar102228{padding-right:var(--t-space-larger);}
:root ._pl-t-space-lar102228{padding-left:var(--t-space-larger);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._pb-t-space-med104641{padding-bottom:var(--t-space-medium);}
:root ._items-center{align-items:center;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._btw-1px{border-top-width:1px;}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._o-0--5{opacity:0.5;}
:root ._o-1{opacity:1;}
:root ._gap-t-space-lar3294{gap:var(--t-space-large);}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._shrink-1{flex-shrink:1;}
:root ._grow-1{flex-grow:1;}
:root ._mt-t-space-sma3456{margin-top:var(--t-space-small);}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._cur-pointer{cursor:pointer;}